import {
  type LimitedSupportLanguageCode,
  type LimitedSupportLanguageName,
  limitedSupportLanguages,
} from 'lib-shared-languages';

/**
 * @deprecated Use an appropriate language export from `lib-shared-languages` instead.
 */
export type LanguageName = LimitedSupportLanguageName;

/**
 * @deprecated Use an appropriate language export from `lib-shared-languages` instead.
 */
export type LanguageCode = LimitedSupportLanguageCode;

/**
 * @deprecated Use an appropriate language export from `lib-shared-languages` instead.
 */
export type Language = { label: LanguageName; code: LanguageCode };

/**
 * @deprecated Use an appropriate language export from `lib-shared-languages` instead.
 */
export const DEFAULT_LANG_CODE = 'en' as const;

/**
 * @deprecated Use an appropriate language export from `lib-shared-languages` instead.
 */
// The `code` field contains a language code as per BCP-37 specifications (https://tools.ietf.org/rfc/bcp/bcp47.txt).
export const languages: Language[] = limitedSupportLanguages.map(
  ({ code, name }) => ({ label: name, code }),
);

/**
 * @deprecated Use an appropriate language export from `lib-shared-languages` instead.
 */
export function findLabelByLanguageCode(
  code: LanguageCode,
): LanguageName | undefined {
  const language = languages.find((l) => l.code === code);
  return language?.label;
}

/**
 * @deprecated Use an appropriate language export from `lib-shared-languages` instead.
 */
export default languages;
